module.exports = __webpack_public_path__ + "static/media/helsinki_1.7ef4c275.jpg";